import { SellOrdersTracker } from '../components/SellOrdersTracker'

export function SellOrders() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Sell Orders</h1>
        <p className="text-eve-muted text-sm">
          Tus órdenes activas en todos los hubs: qué tenés listado, dónde,
          cuánto ISK lockeado, cuándo expira.
        </p>
      </div>

      <SellOrdersTracker />
    </div>
  )
}
